import { render, staticRenderFns } from "./EventMenu.vue?vue&type=template&id=329fb1c9&scoped=true&"
import script from "./EventMenu.vue?vue&type=script&lang=js&"
export * from "./EventMenu.vue?vue&type=script&lang=js&"
import style0 from "./EventMenu.vue?vue&type=style&index=0&id=329fb1c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329fb1c9",
  null
  
)

component.options.__file = "EventMenu.vue"
export default component.exports